// extracted by mini-css-extract-plugin
export default {"checkout":"Checkout_checkout__3zWyd","checkout1":"Checkout_checkout1__kHfFi"};